import { RecordFile } from "../../entities";
import { getAuthorRefForGateway, getAuthorRefFromGateway } from './ParsingUtils';
export default class RecordFileParser {
    static toGateway(file, app) {
        return {
            Author: getAuthorRefForGateway(file.author, app),
            Id: file._id,
            FileName: file.filename,
            FileSignature: file.fileSignature,
            FileSize: file.filesize,
            FileSignedWhen: file.createdTimestamp,
            MimeType: file.mimeType,
            SignedWhen: file.createdTimestamp,
        };
    }
    static fromGateway(fileDescriptor, app) {
        const file = new RecordFile({
            author: getAuthorRefFromGateway(fileDescriptor.Author, app),
            filename: fileDescriptor.FileName,
            mimeType: fileDescriptor.MimeType,
            filesize: fileDescriptor.FileSize,
            fileSignature: fileDescriptor.FileSignature,
        });
        Object.assign(file, {
            _id: fileDescriptor.Id,
            createdTimestamp: fileDescriptor.SignedWhen,
        });
        return file;
    }
}
//# sourceMappingURL=RecordFileParser.js.map